webpackJsonp([21733507128203],{

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/news.dc5f96f5.jpg";

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _header = __webpack_require__(24);
	
	var _header2 = _interopRequireDefault(_header);
	
	__webpack_require__(119);
	
	var _news = __webpack_require__(159);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var NewsTemplate = function (_React$Component) {
	  _inherits(NewsTemplate, _React$Component);
	
	  function NewsTemplate() {
	    _classCallCheck(this, NewsTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NewsTemplate.prototype.render = function render() {
	    var news = this.props.data.contentfulNews;
	    var date = new Date(news.createdAt);
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_header2.default, { image: _news2.default, title: news.title, subtitle: "Published " + date.toLocaleDateString() }),
	      _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          alignItems: "center"
	        }
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "container news-post-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement("div", {
	            className: "col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10 news-post",
	            dangerouslySetInnerHTML: {
	              __html: news.content.childMarkdownRemark.html
	            }
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10 news-post-image" },
	            _react2.default.createElement("img", { src: news.image.file.url })
	          )
	        )
	      )
	    );
	  };
	
	  return NewsTemplate;
	}(_react2.default.Component);
	
	NewsTemplate.propTypes = propTypes;
	
	exports.default = NewsTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-post-js-e535333fde0ffb4af7fa.js